import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { getMyAvailabilityConstants } from 'src/redux/actions/constant';
import myAvailabilityServices from 'src/services/apiServices/my-availability-services/my-availability-services';

const {
  GET_LIST_OF_THERAPIST_AVA_REQUEST,
  GET_LIST_OF_THERAPIST_AVA_SUCCESS,
  GET_LIST_OF_THERAPIST_AVA_FAILURE,
  GET_LIST_OF_THERAPIST_AVA_LOADING,
  GET_LIST_OF_THERAPIST_AVA_RESET,
} = getMyAvailabilityConstants;

function* getTherapistAvailability(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_LIST_OF_THERAPIST_AVA_LOADING });
    const response = yield call(myAvailabilityServices.getTherapistAvail);
    if (response?.status === 200) {
      yield put({ type: GET_LIST_OF_THERAPIST_AVA_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_LIST_OF_THERAPIST_AVA_FAILURE, payload: error });
  }
}

function* getTherapistAvailabilitySaga() {
  yield takeEvery(GET_LIST_OF_THERAPIST_AVA_REQUEST, getTherapistAvailability);
}

export default getTherapistAvailabilitySaga;
